// extracted by mini-css-extract-plugin
export default {"input":"styles_input__LUisg","popup":"styles_popup__xQl24"};